import h from "trader-hyperscript";

const styles = `
* {
  font-family: Arial, sans-serif;
  font-size: 15px;
}

blockquote,h1,h2,h3,img,li,ol,p,ul{
  margin-top:0;
  margin-bottom:0
}

h1 {
  font-size: 24px;
  font-weight: 700;
  line-height: 40px;
  margin-bottom: 12px;
  color: rgb(17, 24, 39);
  text-align: left;
  text-transform: initial;
}

p {
  line-height: 24px;
  margin: 16px 0;
  margin-top: 0px;
  margin-bottom: 20px;
  color: rgb(55, 65, 81);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
}

button {
  line-height: 1.25rem;
  text-decoration: none;
  display: inline-block;
  max-width: 100%;
  width: 100%;
  font-weight: 600;
  text-decoration-line: none;
  color: #fafafa;
  padding: 16px 34px 12px;

  border-radius: 8px;
  font-size: 15px;

  background-color: #142f57;
  border: 0px;
  border-bottom: 3px solid #bcc5d3;

  cursor: pointer;
}

a {
  font-weight: 500;
  color: #142f57;
  text-decoration-line: underline;
  cursor: pointer;
}

.wrapper {
  width: 100%;
  background-color: #f6f6f6;
  padding: 24px;
}
.main_layout {
  max-width:600px;
  margin-left:auto;
  margin-right:auto;
  padding: 1.5rem 3rem;
  width: 100%;
  background-color: white;
  min-height: 200px;
  border-bottom: 4px solid #142f57;
}
@media (max-width: 580px) {
  .wrapper {
    padding: 8px;
  }
  .main_layout {
    padding: 8px;
  }
}

.header_table {
  color: white;
  text-align: center;
  padding-right: 8px;
  font-weight: 600;
  font-size: 18px;
  height: 48px;
  background-color: #142f57 !important;
  border-bottom: 4px solid orange !important;
}
@media (prefers-color-scheme-dark) {
  .header_table {
    color: white;
    background-color: #142f57 !important;
    border-bottom: 4px solid orange !important;
  }
  .main_layout {
    border-bottom: 4px solid #142f57;
  }
}
  `;

const newHeader = (opts: { schoolname: string; schoolurl: string }) => (
  <table
    align="center"
    width="100%"
    role="presentation"
    cellspacing="0"
    cellpadding="0"
    border="0"
    data-remove-from-inner-text="true"
    style="max-width:600px;margin-left:auto;margin-right:auto;padding:.5rem; width: 100%; background-color: white; border-collapse: collapse"
  >
    <tbody>
      <tr>
        <td className="header_table">{opts.schoolname}</td>
      </tr>
      {opts.schoolurl.includes(
        // They don't want their students to use classy yet
        "cultuurcentrumboogiewoogie",
        // TODO schoolspecific
      ) ? (
        []
      ) : (
        <tr>
          <td style="text-align: right">
            <a
              href={opts.schoolurl}
              style="font-size: 12px; position: relative; top: -6px"
            >
              {opts.schoolurl.replace("https://", "").replace("http://", "")}
            </a>
          </td>
        </tr>
      )}
    </tbody>
  </table>
);

export function makeEmailWithNewTemplate(
  opts: { schoolname: string; schoolurl: string },
  content: HTMLElement | HTMLElement[],
): HTMLElement {
  const stylesTag = h("style", {});
  stylesTag.textContent = styles;

  return (
    <html lang="en">
      <head>
        <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
        {stylesTag}
      </head>
      <body>
        <table style="width: 100%">
          <tbody>
            <tr>
              <td className="wrapper">
                {newHeader(opts)}
                <table
                  align="center"
                  width="100%"
                  role="presentation"
                  cellspacing="0"
                  cellpadding="0"
                  border="0"
                  className="main_layout"
                >
                  <tbody>
                    <tr style="width:100%">
                      <td>{content}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </body>
    </html>
  );
}
